import { Download, Plus, RefreshCw } from "lucide-react";
import { DataTable } from "../../components/ui/DataTable";
import { StatusPill } from "../../components/ui/StatusPill";
import { getAdminModule } from "../../data/admin";

type AdminWorkspacePageProps = {
  moduleId?: string;
};

export function AdminWorkspacePage({ moduleId = "dashboard" }: AdminWorkspacePageProps) {
  const module = getAdminModule(moduleId);

  return (
    <main className="admin-main">
      <div className="page-head">
        <div>
          <h1>{module.title}</h1>
          <p>{module.description}</p>
        </div>
        <div className="page-actions">
          <button className="admin-secondary" type="button">
            <Download aria-hidden="true" />
            {module.secondaryAction}
          </button>
          <button className="admin-primary" type="button">
            <Plus aria-hidden="true" />
            {module.primaryAction}
          </button>
        </div>
      </div>

      <div className="metrics">
        {module.metrics.map((metric) => (
          <div className="metric" key={metric.label}>
            <span>{metric.label}</span>
            <strong>{metric.value}</strong>
            <small className={metric.tone ? `tone-${metric.tone}` : undefined}>{metric.delta}</small>
          </div>
        ))}
      </div>

      <div className="two-col">
        <section className="admin-panel">
          <div className="admin-panel-head">
            <h2>{module.title} gần đây</h2>
            <div className="filters">
              <input placeholder="Tìm theo mã / tên" />
              <select defaultValue="all">
                <option value="all">Tất cả trạng thái</option>
                <option value="open">Đang mở</option>
                <option value="done">Hoàn tất</option>
              </select>
              <button type="button">
                <RefreshCw aria-hidden="true" />
                Đồng bộ
              </button>
            </div>
          </div>
          <DataTable columns={module.columns} rows={module.rows} caption={`${module.title} gần đây`} />
        </section>
        <aside className="admin-panel inspector">
          <h3>Việc cần chú ý</h3>
          <div className="inspector-grid">
            {module.inspector.map((item) => (
              <div className="inspector-row" key={item.label}>
                <span>{item.label}</span>
                <strong>{item.value}</strong>
                <StatusPill tone={item.tone === "danger" ? "red" : item.tone === "warn" ? "orange" : "green"}>
                  {item.tone === "danger" ? "Khẩn" : item.tone === "warn" ? "Theo dõi" : "Ổn"}
                </StatusPill>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </main>
  );
}
